var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 38,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#7d9aa7}.cls-2{fill:none}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_794",
    "data-name": "Group 794",
    transform: "translate(-18 -29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_790",
    "data-name": "Group 790"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1406",
    "data-name": "Path 1406",
    className: "cls-1",
    d: "M34.8 67H29a1 1 0 0 1-.7-1.712l14-13.8a1 1 0 0 1 1.7.712v5.6a1 1 0 0 1-.293.707l-8.2 8.2A1 1 0 0 1 34.8 67zm-3.361-2h2.946L42 57.386v-2.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_793",
    "data-name": "Group 793"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_789",
    "data-name": "Group 789"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_647",
    "data-name": "Rectangle 647",
    className: "cls-2",
    transform: "translate(43 34)",
    d: "M0 0h4v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1404",
    "data-name": "Path 1404",
    className: "cls-1",
    d: "M47 67h-4a1 1 0 0 1-1-1V34a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v32a1 1 0 0 1-1 1zm-3-2h2V35h-2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1405",
    "data-name": "Path 1405",
    className: "cls-2",
    d: "M43 52.2 29 66h5.8l8.2-8.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_791",
    "data-name": "Group 791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1407",
    "data-name": "Path 1407",
    className: "cls-2",
    d: "M47 52.2 61 66h-5.8l-2.734-2.734L47 57.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1408",
    "data-name": "Path 1408",
    className: "cls-1",
    d: "M61.02 67H55.2a1 1 0 0 1-.707-.293l-8.2-8.2A1 1 0 0 1 46 57.8v-5.6a1 1 0 0 1 1.7-.712L61.593 65.18A1 1 0 0 1 61.02 67zm-5.406-2h2.946L48 54.59v2.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_792",
    "data-name": "Group 792"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1409",
    "data-name": "Path 1409",
    className: "cls-2",
    d: "M69 34H21a2 2 0 0 1-2-2 2 2 0 0 1 2-2h48a2 2 0 0 1 2 2 2 2 0 0 1-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1410",
    "data-name": "Path 1410",
    className: "cls-1",
    d: "M69 35H21a3 3 0 0 1 0-6h48a3 3 0 0 1 0 6zm-48-4a1 1 0 0 0 0 2h48a1 1 0 0 0 0-2z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.6e55309086f131d14f13631b17d6b616.svg";
export { ForwardRef as ReactComponent };